import { render, staticRenderFns } from "./ContractForm.vue?vue&type=template&id=2bb9671e&scoped=true&"
import script from "./ContractForm.vue?vue&type=script&lang=js&"
export * from "./ContractForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb9671e",
  null
  
)

export default component.exports